// extracted by mini-css-extract-plugin
export default {"menu":"AdminLayout_menu__5WCEq"};